import { useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';
import {
    useComparisonCompanies,
    useComparisonSchemaTypes,
    useComparisonSchemaActions,
} from '../../context';

function SchemaTypeSelector() {
    const companies = useComparisonCompanies();
    const selectedSchemaTypes = useComparisonSchemaTypes();
    const { setSchemaTypes } = useComparisonSchemaActions();

    const schemaTypeOptions = useMemo(() => {
        const schemaNames = new Set<string>();
        for (const company of companies) {
            for (const schema of company.schemas) {
                if (schema.branchType === 'MAIN') {
                    schemaNames.add(schema.name);
                }
            }
        }
        return Array.from(schemaNames)
            .sort()
            .map((name) => ({
                key: name,
                value: name,
                text: name,
            }));
    }, [companies]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleChange = (_e: any, { value }: any) => {
        setSchemaTypes(value as string[]);
    };

    return (
        <div className="schema-type-selector">
            <label>Schema Types</label>
            <Dropdown
                placeholder="Select schema types..."
                fluid
                multiple
                search
                selection
                options={schemaTypeOptions}
                value={selectedSchemaTypes}
                onChange={handleChange}
                disabled={companies.length === 0}
            />
        </div>
    );
}

export default SchemaTypeSelector;
